export default __webpack_public_path__ + "static/media/gmc.46887674.svg";